import { useParams } from 'react-router-dom';
import { CampaignDetailContainer } from '@/features/advertising';

export default function AdsCampaignDetailPage() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return null;
  }

  return <CampaignDetailContainer campaignId={id} />;
}
